import {
  Modal, ModalBody, ModalContent, ModalOverlay,
} from "@chakra-ui/react";
import CustomCloseButton from "components/CustomCloseButton";
import { ReminderRow } from "../types";
import ReminderComposer from "./ReminderComposer";

interface ReminderComposerModalProps {
  isOpen: boolean;
  onClose: () => void;
  row: ReminderRow;
  newHireFullName?: string;
  newHireId?: string;
}

export default function ReminderComposerModal({
  isOpen, onClose, row, newHireFullName, newHireId,
}: ReminderComposerModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" isCentered>
      <ModalOverlay />
      <ModalContent maxW="640px">
        <CustomCloseButton onClick={onClose} top="2.5" />
        <ModalBody pt={6} pb={6}>
          <ReminderComposer
            row={row}
            newHireFullName={newHireFullName}
            newHireId={newHireId}
            onBack={onClose}
            onSent={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
